import { AbstractControl, FormArray, ValidationErrors } from '@angular/forms';

export function uniqueSectionNamesForActiveType(activeType: string) {
    return (arr: AbstractControl): ValidationErrors | null => {
        if (!(arr instanceof FormArray)) return null;

        // collect only the sections whose first task has this type
        const entries: { ctrl: AbstractControl; name: string }[] = [];

        arr.controls.forEach((sectionGroup) => {
            const nameCtrl = sectionGroup.get('name');
            const tasksArr = sectionGroup.get('workflowTasks') as FormArray;
            if (!nameCtrl || !tasksArr?.length) return;

            // assume your section's type is the first task’s type
            const type = tasksArr.at(0).get('taskType')?.value;
            if (type !== activeType) return;

            const raw = (nameCtrl.value || '').trim().toLowerCase();
            if (!raw) return;

            entries.push({ ctrl: nameCtrl, name: raw });
        });

        // count names
        const counts = entries.reduce<Record<string, number>>((acc, e) => {
            acc[e.name] = (acc[e.name] || 0) + 1;
            return acc;
        }, {});

        // mark duplicates
        entries.forEach(({ ctrl, name }) => {
            if (counts[name] > 1) {
                ctrl.setErrors({ ...ctrl.errors, notUniqueForType: true });
            } else if (ctrl.hasError('notUniqueForType')) {
                const errs = { ...ctrl.errors! };
                delete errs['notUniqueForType'];
                ctrl.setErrors(Object.keys(errs).length ? errs : null);
            }
        });

        return null;
    };
}
